import React from "react";
import {BreadCrumbItem} from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import FormSection from "./FormSection";

const breadCrumbs: BreadCrumbItem[] = [
    {
        path: "/",
        label: "Inicio"
    },
    {
        path: "/productos",
        label: "Productos",
    },
    {
        path: "/editar",
        label: "Editar",
        isActive: true
    }
]

function EditarProducto(){
    return (
        <Page title="Edición de Producto" description="Modificación de un producto." breadCrumbs={breadCrumbs}>
            <FormSection />
        </Page>
    );
}

export default EditarProducto;